import Button from 'components/form-elements/buttons/Button'
import Input from 'components/form-elements/input/Input'
import { useRequest } from 'hooks/useRequest'
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import useToast from 'hooks/useToast';
import images from 'assets/images/images'
import { useEffect } from 'react'
import LoaderTwo from 'pages/LoaderTwo'
import useTranslate from 'hooks/useTranslate'

const StageForgotStep1 = () => {

    const [request,loading] = useRequest()
    const { showToast } = useToast()
    const navigate = useNavigate();

    const [mail, setMail] = useState()
    const {t} = useTranslate()

	const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA


    const setPassword = async() => {
        if (!mail) {
            showToast(t('enterEmailAddress'), 'error')

        } else {
            await window.grecaptcha.ready(function () {
                window.grecaptcha.execute(recaptchaSiteKey, { action: 'submit' }).then(function (token) {
            request('/InternalAuth/PasswordResetRequest', {
                method: 'POST',
                data: {
                    email: mail,
                    token:token,
                },

            }).then((res) => {
                if (res?.data) {
                    if (res?.data?.ok) {
                        showToast(t('mailSended'), 'success')
                        navigate("/sifremi-unuttum")
                    }
                }
            })
        })
    })
        }

    }


    const mailInput = (e, name) => {
        if (name) {
            setMail((prev) => ({ ...prev, [name]: e }))
        }
        else {
            setMail(e.target.value)
        }
    }

    useEffect(() => {
        document.title = t('forgotPassword');
    }, []);

    return (
        <div className="d-flex flex-column gap-4 w-fit-content m-auto p-3">
            <LoaderTwo isDataLoading={loading} />
            <div style={{cursor:"pointer"}} className="header-l mt-5">
                {t('forgotPassword')}
            </div>
            <Input containerClassName={"m-0"}
                className={''} placeholder={t('labelMail')}
                type={'text'} textLabel={t('labelMailLong')}
                name='mail'
                value={mail}
                onChange={mailInput}
            />
            <div className='register-container-btnGroup stage3-btn-group'>
                <Link to={'/uye-girisi'}>
                    <Button className={"stageTwoBtnWhite"} icon={images.leftArrow} text={""} />
                </Link>
                <Button onClick={setPassword} className={"stageTwoBtnRed"} icon={''} text={t('continue')} />

            </div>
        </div>
    )
}

export default StageForgotStep1